'use client'

import { useEffect, useRef } from 'react'

type FusedeckTrackingPayload = Record<string, unknown>

const pushFusedeckEvent = (payload: FusedeckTrackingPayload) => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    const trackingWindow = window as Window & {
      fdData?: FusedeckTrackingPayload[]
    }
    trackingWindow.fdData = trackingWindow.fdData || []
    trackingWindow.fdData.push(payload)

    console.log('fdData', payload)
  } catch (error) {
    console.log('fdData error:', error)
  }
}

export const trackFusedeckEvent = (payload: FusedeckTrackingPayload) => {
  pushFusedeckEvent(payload)
}

export const useTrackFusedeckEventOnMount = (
  payload: FusedeckTrackingPayload
) => {
  const payloadRef = useRef(payload)

  useEffect(() => {
    pushFusedeckEvent(payloadRef.current)
  }, [])
}
